import { Location } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewContainerRef, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Auth, Configuration, HttpClientCustom } from '../../shared';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';

@Component({
    selector: "[notificationLangGrid]",
    templateUrl: "notificationLangGridComponent.html"
})
export class NotificationLangGridComponent implements OnChanges {

    @Input() notification: any;
    public notificationLangPageData: any = [];
    public _baseUrl: string;
    public trackHides: number;
    public editLang: boolean = false;
    @Output()
    public editLangFlag: EventEmitter<boolean> = new EventEmitter<boolean>();
    public editingLang: any;
    public search: any = {
        page: 1,
        pageSize: 10,

    };
    public showLoading: boolean;
    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public _location: Location,
        public vcr: ViewContainerRef,
        public translate: TranslateService) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
    }

    public ngOnChanges() {
        if (this.notification && this.notification.id) {
            this.search.notificationId = this.notification.id;
            this.fetchNotificationLang();
        }
    }

    public fetchNotificationLang() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/notification/lang/search';
        self.showLoading = false;
        self.http.post(url, this.search).subscribe((result) => {
            self.notificationLangPageData = result;
            self.showLoading = false;
        }, (error) => {
            this._toaster.showError("Can not load notification language data");
            self.showLoading = false;
        });
    }

    public cloneNotification(): any {
        return {
            name: this.notification.name,
            description: this.notification.description,
            messageTemplate: this.notification.messageTemplate,
            subjectTemplate: this.notification.subjectTemplate,
            notificationId: this.notification.id
        }
    }

    public tableActions(index: number) {
        this.trackHides = index;
    }
    public edit(notificationLang) {
        this.editLangFlag.emit(true);
        this.editingLang = notificationLang;
        this.editLang = true;
    }

    public add() {
        this.editLangFlag.emit(true);
        this.editingLang = this.cloneNotification();
        this.editLang = true;
    }

    public save() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/notification/lang/save';
        self.http.post(url, this.editingLang).subscribe((result) => {
            this._toaster.showError("Notification lang saved");
            this.editLang = false;
            this.fetchNotificationLang();
            this.editLangFlag.emit(false);
        }, (error) => {
            if (error.error && error.error.status == 'CONFLICT') {
                this._toaster.showError("Can not save. same language exists with notification");
            } else {
                this._toaster.showError("Not able to save lang .Some thing went wrong .");
                self.showLoading = false;
            }
        });
    }

    public cancel() {
        this.editLang = false;
        this.editingLang = null;
        this.editLangFlag.emit(false);
    }

    @HostListener('window:click', ['$event'])
    public clickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(() => {
                this.trackHides = null;
            }, 100);
        }
    }

    public clicked() {
        this.trackHides = null;
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/notificationEditor/notificationLangGridComponent.ts